<app-kpi-widget
  [title]="'fuelChanges.widgets.totalFuelLosses' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="totalFuelLossPercentageChange"
  [costDifference]="difference"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [totalCost]="cost"
  [isUptrendPositive]="isUptrendPositive"
  [dropdownOptions]="dropdownOptions"
  [selectedDropdownValue]="selectedUnit"
  (clicked)="openTotalFuelLossModal()"
  (dropdownChanged)="onDropdownChanged($event)"
  [dropdownEnabled]="false">
</app-kpi-widget>